import { Select, chakraComponents } from "chakra-react-select";
import { useEffect, useState } from "react";
import { Favorites } from "../../../../interfaces/defaultInterfaces";
import FavoritesAPi from "../../../../services/favoritesApi";

export default function SelectFavorite({ cliente, setFavorite }: any) {
  const [favoriteList, setFavoriteList] = useState(Array<Favorites>);
  const [value, setValue] = useState(0);
  const [search, setSearch] = useState("");

  async function getfavoriteList() {
    console.log("cliente", cliente);
    if (cliente != 0) {
      try {
        const response = await FavoritesAPi.getFavorecidosList(
          1,
          50,
          cliente,
          search
        );
        setFavoriteList(response.data);
        console.log("res", response);
      } catch (error) {
        console.log("error", error);
      }
    }
  }

  useEffect(() => {
    getfavoriteList();
  }, [cliente, search]);

  const clientOptions =
    favoriteList &&
    favoriteList.map((client) => {
      return {
        key: client.id,
        value: client.id,
        label: client.nomeTitular,
      };
    });

  function onChangeInput(item: any) {
    // console.log("evento do input", item)
    setSearch(item);
  }

  function onChangeClientFilter(e: any) {
    setValue(Number(e.value));
    const favorecido = favoriteList.filter(
      (item: Favorites) => item.id === Number(e.value)
    );
    setFavorite(favorecido[0]);
  }

  return (
    <>
      <Select
        focusBorderColor="blue.500"
        name="colors"
        // isMulti
        options={clientOptions}
        // value={cliente}
        placeholder="Selecionar Favorecidos"
        closeMenuOnSelect={true}
        size="md"
        onChange={(e: any) => {
          onChangeClientFilter(e);
        }}
        onInputChange={(e: any) => {
          onChangeInput(e);
        }}
      ></Select>
    </>
  );
}
